module.exports = __webpack_public_path__ + "static/media/logo_principal.d2ce35e3.svg";